
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  isAuthenticated: false,
  userType: 0,
  userId: '',
  userName: '',
  firstName: '',
  lastName: '',
  officialEmail: '',
  memberTypes: '',
  createdBy: '',
  countryList: [],
  pdfData: null,
  designation: '',
  rfqCountRefreshKey: 0,
  rfqCounts: null,
  // { [menuUrl]: string[] } — populated after login via roleMenu/{kpostId}
  menuPrivileges: {},
}
